import React, { Component } from "react";
import { connect } from "react-redux";
import { Row } from "simple-flexbox";
import { withRouter } from "react-router-dom";
import ContentContainer from "../../components/container/ContainerComponent";
import MaterialTable from "material-table";
import {deleteJobSpot, jobSpotList} from "../../actions/jobspot/jobspot_action";

import MenuItem from "@material-ui/core/MenuItem";
import DetailButtonComponent from "../../components/global-components/DetailButtonComponent";
import { TablePagination } from "@material-ui/core";
import { Paper } from "@material-ui/core";
import HeaderJobSpot from "./Header_JobSpot";
import ModalFilter from "./Modal_filter";
import {
    deleteJobSpotError,
    deleteJobSpotPending,
    getJobSpot,
    getJobSpotError,
    getJobSpotPending
} from "../../reducers/jobspot/jobspot";
import ModalApproval from "./Modal_Approval";

class ListJobSpot extends Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
        this.state = {
            showFilter: false,
            showModalApprove: false,
            search: "",
            province: "",
            city: "",
            published_start_date: "",
            published_end_date: "",
            published_only: "false",
            jobSpotName: "",
            id: null,
            columns: [
                {
                    title: "No",
                    render: (rowData) => {
                        return <>{rowData.no}</>;
                    },
                    width: 20,
                    headerStyle: {
                        paddingLeft: 40,
                    },
                    cellStyle: {
                        paddingLeft: 40,
                    },
                },
                { title: "Nama Pekerjaan", field: "name" },
                { title: "Instansi",  field: "instance" },
                { title: "Tanggal Posting", field: "created_at" },
                {
                    title: "Durasi Posting",
                    field: "posted_range",
                },
                {
                    title: "",
                    render: ({ id, name }) =>
                        <DetailButtonComponent>
                            <MenuItem onClick={() => this.detailRecord(id)}>
                                Detail
                            </MenuItem>
                            <MenuItem onClick={() => this.deleteRecord(id, name)}>
                                <span style={{color: '#F26664'}}>Hapus</span>
                            </MenuItem>
                        </DetailButtonComponent>
                },
            ],
        };
        this.handleRefresh = this.handleRefresh.bind(this);
        this.handleOpenFilterModal = this.handleOpenFilterModal.bind(this);
        this.deleteRecord = this.deleteRecord.bind(this);
    }

    handleRefresh(state) {
        this.setState(state);
        this.setState({ id: null });
        this.tableRef.current && this.tableRef.current.onQueryChange();
    }

    handleOpenFilterModal() {
        this.setState({
            showFilter: true,
        });
    }

    detailRecord(id) {
        this.props.history.push(`/jobspot/detail/${id}`);
    }

    deleteRecord(id, name) {
        this.setState({ showModalApprove: true });
        this.setState({ id: id, jobSpotName: name });
    }


    // tableRef = React.createRef();
    render() {
        const { showFilter, showModalApprove, jobSpotName } = this.state;
        const { jobSpotList, jobSpotList_data } = this.props;
        let data = [];
        let records_total = "";
        let length = "";
        if (jobSpotList_data) {
            data = jobSpotList_data;
            records_total = data.records_total;
            length = data.data.length;
        }
        return (
            <ContentContainer>
                <ModalFilter
                    show={showFilter}
                    onHide={() => this.setState({ showFilter: false })}
                    handleRefresh={this.handleRefresh}
                />
                <ModalApproval
                    idJobSpot={this.state.id}
                    handleRefresh={this.handleRefresh}
                    show={showModalApprove}
                    jobSpotName={jobSpotName}
                    onHide={() => this.setState({ showModalApprove: false })}
                />
                <HeaderJobSpot handleRefresh={this.handleRefresh} onShowModal={this.handleOpenFilterModal} />
                <MaterialTable
                    tableRef={this.tableRef}
                    title="Jobspot"
                    columns={this.state.columns}
                    data={(query) =>
                        new Promise((resolve, reject) => {
                            let param = {
                                page: query.page + 1,
                                length: 10,
                                search_text: this.state.search,
                                province: this.state.province,
                                city: this.state.city,
                                published_start_date: this.state.published_start_date,
                                published_end_date: this.state.published_end_date,
                                published_only: this.state.published_only,
                                id: "",
                            };
                            jobSpotList(param, resolve, reject);
                        })
                    }
                    options={{
                        paginationType: "stepped",
                        pageSize: 10,
                        pageSizeOptions: [],
                        showTitle: false,
                        search: false,
                        headerStyle: {
                            color: "#9DA6BA",
                            backgroundColor: "#F8F9FB99",
                        },
                    }}
                    components={{
                        Toolbar: () => <div />,
                        Container: (props) => <Paper {...props} elevation={0} />,
                        Pagination: (props) => (
                            <Row
                                horizontal="space-between"
                                style={{ paddingRight: 20, paddingLeft: 20 }}
                            >
                                <Row
                                    style={{
                                        width: "50%",
                                        borderBottom: "1px solid rgba(224, 224, 224)",
                                    }}
                                    vertical="center"
                                >
                                    <p>
                                        {" "}
                                        Menampilkan {length} dari {records_total} data{" "}
                                    </p>
                                </Row>
                                <TablePagination
                                    {...props}
                                    color="primary"
                                    labelRowsPerPage={
                                        <div style={{ fontSize: 14 }}>{props.labelRowsPerPage}</div>
                                    }
                                    labelDisplayedRows={(row) => (
                                        <div style={{ fontSize: 14, color: "red" }}>
                                            {/* {props.labelDisplayedRows(row)} */}
                                        </div>
                                    )}
                                    SelectProps={{
                                        style: {
                                            fontSize: 20,
                                        },
                                    }}
                                />
                            </Row>
                        ),
                    }}
                />
            </ContentContainer>
        );
    }
}

function mapStateToProps({ jobSpot }) {
    return {
        jobSpotList_pending: getJobSpotPending(jobSpot),
        jobSpotList_data: getJobSpot(jobSpot),
        jobSpotList_error: getJobSpotError(jobSpot),
        jobSpotDelete_pending: deleteJobSpotPending(jobSpot),
        jobSpotDelete_error: deleteJobSpotError(jobSpot)
    };
}

export default connect(mapStateToProps, { jobSpotList, deleteJobSpot })(
    withRouter(ListJobSpot)
);
